export const SOLICITACOES_LISTA = 'SOLICITACOES_LISTA';
export const setLista = listaSolicitacoes => ({
  type: SOLICITACOES_LISTA,
  payload: {
    listaSolicitacoes
  }
});

export const TOTAL_SOLICITACOES_SOLICITADAS = 'TOTAL_SOLICITACOES_SOLICITADAS';
export const setTotalSolicitado = totalSolicitado => ({
  type: TOTAL_SOLICITACOES_SOLICITADAS,
  payload: {
    totalSolicitado
  }
});



// WEBPACK FOOTER //
// ./src/pages/solicitacao/solicitacao.action.js